// Sets the transition and width style property and return the element's client width afterwards
const fn_helper_setStyle = (elem, width = null) => {
  elem.style.transition = width === "auto" ? "none" : "";
  elem.style.width = width ?? "";
  return elem.clientWidth;
};

// Sets the transition and width style property and return the element's client width afterwards
const fn_helper_transitionWidth = (elem) => {
  // Get the current size
  const w_old = elem.clientWidth;
  // Set width to auto and disable transition to get the actual element width
  const w_new = fn_helper_setStyle(elem, "auto");
  // Reset transition and with to return to default state
  fn_helper_setStyle(elem, `${w_old}px`);

  // Wait for one frame, then explicitly set the width to trigger the animation if the width has changed
  if (w_old !== w_new)
    window.requestAnimationFrame(() => {
      fn_helper_setStyle(elem, `${w_new}px`);
    });
};

// Contact Bar animation elements must be added to this observer o make sure their size is adjusted whenever the content
// size changes
const contactBarContentResizeObserver = new ResizeObserver((entries) => {
  for (const entry of entries)
    if (
      entry.contentRect &&
      entry.target.dataset.transitioning !== "1" && // Don't trigger while a transition is running
      entry.contentRect.height * entry.contentRect.width > 0 && // Don't trigger if the element is not visible
      entry.target.style.width // Don't trigger if the element has no specified width
    )
      fn_helper_transitionWidth(entry.target);
});

document.addEventListener(
  "DOMContentLoaded",
  () => {
    document.querySelectorAll("#contact-bar>div").forEach((element) => {
      // Check if our contact bar item has a hidden sub item
      const animationElement = element.querySelector("div:last-child:not(:only-child)");
      if (!animationElement) return;

      // Add the animation element to the resize observer
      contactBarContentResizeObserver.observe(animationElement);

      // When entering...
      element.addEventListener(
        "mouseenter",
        () =>
          // ... begin transition
          fn_helper_transitionWidth(animationElement),
        { passive: true }
      );

      // When leaving...
      element.addEventListener(
        "mouseleave",
        () =>
          // ... reset the style
          fn_helper_setStyle(animationElement),
        { passive: true }
      );

      // The resize observer should not trigger during transitions, so we need to record the current transition state
      animationElement.addEventListener("transitionstart", () => (animationElement.dataset.transitioning = "1"), {
        passive: true,
      });
      animationElement.addEventListener("transitionend", () => (animationElement.dataset.transitioning = "0"), {
        passive: true,
      });
      animationElement.addEventListener("transitioncancel", () => (animationElement.dataset.transitioning = "0"), {
        passive: true,
      });
    });
  },
  { passive: true }
);
